"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const alpinejs_1 = require("alpinejs");
const collapse_1 = require("@alpinejs/collapse");
const focus_1 = require("@alpinejs/focus");
const _alpineData_1 = require("./_alpineData");
const _forms_1 = require("./_forms");
const _helpers_1 = require("./_helpers");
// Add gtag helper
window.gtag = function () {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
};
// Set-up Alpine data
window.data = {
    mobileMenu: (0, _alpineData_1.mobileMenu)(),
    filterMenu: (0, _alpineData_1.filterMenu)(),
    aboutText: (0, _alpineData_1.aboutText)(),
    modalManager: (0, _alpineData_1.modalManager)(),
    cookieManager: (0, _alpineData_1.cookieManager)(),
    aanbodSelectie: (0, _alpineData_1.aanbodSelectie)(),
    objectMedia: (0, _alpineData_1.objectMedia)(),
    relatedObjects: (0, _alpineData_1.relatedObjects)(),
    buitengewoonGroen: (0, _alpineData_1.buitengewoonGroen)()
};
window.forms = {
    contactForm: (0, _forms_1.contactForm)(),
    bezichtigingForm: (0, _forms_1.bezichtigingForm)(),
    nieuwsbriefForm: (0, _forms_1.nieuwsbriefForm)(),
    nieuwsbriefBuitengewoon: (0, _forms_1.nieuwsbriefBuitengewoon)(),
    bouwkundigeKeuringForm: (0, _forms_1.bouwkundigeKeuringForm)(),
    taxatieForm: (0, _forms_1.taxatieForm)(),
    searchForm: (0, _forms_1.searchForm)(),
};
// Make isOfficeHours globally available
window.isOfficeHours = _helpers_1.isOfficeHours;
window.formatMoney = _helpers_1.formatMoney;
window.youtubeLoader = _helpers_1.youtubeLoader;
window.Alpine = alpinejs_1.default;
alpinejs_1.default.plugin(collapse_1.default);
alpinejs_1.default.plugin(focus_1.default);
alpinejs_1.default.start();
